import React, { useEffect, createElement } from 'react';
import { StickyTopBar } from './components/StickyTopBar';
import { HeroSection } from './components/HeroSection';
import { SocialProofBar } from './components/SocialProofBar';
import { ShortTestimonials } from './components/ShortTestimonials';
import { PainPointsSection } from './components/PainPointsSection';
import { ProductShowcase } from './components/ProductShowcase';
import { TomosDetail } from './components/TomosDetail';
import { IncludesSection } from './components/IncludesSection';
import { BonusSection } from './components/BonusSection';
import { CountdownSection } from './components/CountdownSection';
import { PricingSection } from './components/PricingSection';
import { FullTestimonials } from './components/FullTestimonials';
import { ForWhomSection } from './components/ForWhomSection';
import { GuaranteeSection } from './components/GuaranteeSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { Footer } from './components/Footer';
import { SocialProofPopup } from './components/SocialProofPopup';
const META_PIXEL_ID = 'EAAeYTLmndI8BQ9Ci8Qzq0auCJktixgiB6LjIVG4TSdbAfyQ0tZASG2q3KLs6qBBHgWP6ZCWPZCCVW0H7Hjo5udkauaUesQU9v4qDjIaAI3w4HBOT43JXDgQWbia7E62sjgZCgfiGZBsZC1D5S9Br6ZCenfOavdHAM6DQEETAvGHH8oAC3kmpOFDb3Lz8tAvrrbqEgZDZD';
export function App() {
  useEffect(() => {
    // Performance optimizations: Preconnect and Preload
    const head = document.head;
    const preconnects = ['https://cdn.magicpatterns.com', 'https://fonts.googleapis.com', 'https://fonts.gstatic.com'];
    preconnects.forEach(url => {
      const link = document.createElement('link');
      link.rel = 'preconnect';
      link.href = url;
      head.appendChild(link);
      const dnsPrefetch = document.createElement('link');
      dnsPrefetch.rel = 'dns-prefetch';
      dnsPrefetch.href = url;
      head.appendChild(dnsPrefetch);
    });
    // Preload LCP Image
    const preloadLink = document.createElement('link');
    preloadLink.rel = 'preload';
    preloadLink.as = 'image';
    preloadLink.href = 'https://cdn.magicpatterns.com/uploads/6RNKumnwqYoEX1a1ns37fg/carpintero_hero_mobile_768.webp';
    preloadLink.imageSrcset = 'https://cdn.magicpatterns.com/uploads/6RNKumnwqYoEX1a1ns37fg/carpintero_hero_mobile_768.webp';
    preloadLink.fetchPriority = 'high';
    head.appendChild(preloadLink);
    // Meta Pixel initialization
    if (typeof window !== 'undefined' && !(window as any).fbq) {
      const f = window as any;
      const n = f.fbq = function (...args: any[]) {
        if (n.callMethod) {
          n.callMethod.apply(n, args);
        } else {
          n.queue.push(args);
        }
      };
      if (!f._fbq) f._fbq = n;
      n.push = n;
      n.loaded = true;
      n.version = '2.0';
      n.queue = [] as any[];
      // Load the Facebook Pixel script
      const script = document.createElement('script');
      script.async = true;
      script.defer = true;
      script.src = 'https://connect.facebook.net/en_US/fbevents.js';
      document.head.appendChild(script);
      (window as any).fbq('init', META_PIXEL_ID);
      (window as any).fbq('track', 'PageView');
      // Add noscript fallback
      const noscript = document.createElement('noscript');
      const img = document.createElement('img');
      img.height = 1;
      img.width = 1;
      img.style.display = 'none';
      img.src = `https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`;
      noscript.appendChild(img);
      document.body.appendChild(noscript);
    }
  }, []);
  return <div className="min-h-screen bg-white font-sans overflow-x-hidden" data-id="element-0">
      <StickyTopBar data-id="element-1" />
      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <SocialProofBar data-id="element-4" />
        <ShortTestimonials data-id="element-5" />
        <PainPointsSection data-id="element-6" />
        <ProductShowcase data-id="element-7" />
        <TomosDetail data-id="element-8" />
        <IncludesSection data-id="element-9" />
        <BonusSection data-id="element-10" />
        <CountdownSection data-id="element-11" />
        <PricingSection data-id="element-12" />
        <FullTestimonials data-id="element-13" />
        <ForWhomSection data-id="element-14" />
        <GuaranteeSection data-id="element-15" />
        <FAQSection data-id="element-16" />
        <FinalCTASection data-id="element-17" />
      </main>
      <Footer data-id="element-18" />
      <SocialProofPopup data-id="element-19" />
    </div>;
}